export enum RiskAcceptanceStatus {
  Pending = 'PENDING',
  Accepted = 'ACCEPTED',
  Rejected = 'REJECTED',
  /** Set by an admin reset — re-prompts on the next PASSED submission. */
  Aborted = 'ABORTED',
}
